import styled from '@emotion/styled';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ChevronDown as IconExpandMore } from 'lucide-react';
import React from 'react';

export type ArrowDirection = 'UP' | 'RIGHT' | 'DOWN' | 'LEFT';
type ArrowProps = {
  dir: ArrowDirection;
};

type DEGRESS = { [key in ArrowDirection]: number };
const degrees: DEGRESS = {
  UP: 180,
  RIGHT: -90,
  DOWN: 0,
  LEFT: 90
};

const Icon = styled(IconExpandMore)<ArrowProps & SvgIconProps>`
  transition: ${(p) =>
    p.theme.transitions.create('transform', {
      duration: p.theme.transitions.duration.shortest
    })};
  transform: rotate(${(p) => degrees[p.dir as ArrowDirection]}deg);
`;

export const Arrow = (props: ArrowProps & SvgIconProps) => {
  // @ts-ignore
  return <Icon {...props} />;
};
